'use strict';

const defaultKnownFields = ["apiVersion", "kind", "metadata", "spec"];
class NoForeignRootFieldsEntityPolicy {
  knownFields;
  constructor(knownFields = defaultKnownFields) {
    this.knownFields = knownFields;
  }
  async enforce(entity) {
    for (const field of Object.keys(entity)) {
      if (!this.knownFields.includes(field)) {
        throw new Error(`Unknown field ${field}`);
      }
    }
    return entity;
  }
}

exports.NoForeignRootFieldsEntityPolicy = NoForeignRootFieldsEntityPolicy;
//# sourceMappingURL=NoForeignRootFieldsEntityPolicy.cjs.js.map
